@use '@maltjoy/themes/src/tokens/src/spacing';

:host {
  /*
   * @prop --wrapper-gap: customize spacing between elements. Uses css flex gap.
   */
  --wrapper-gap: var(--joy-core-spacing-8) var(--joy-core-spacing-4);

  display: block;
  margin-bottom: var(--joy-core-spacing-8);
}

:host([no-margin]) {
  margin-bottom: 0 !important;
}

@mixin generate-row-gaps {
    @each $i, $value in spacing.$SPACING {
        &-#{$i} {
            row-gap: var(--joy-core-spacing-#{$i});
        }
    }
}

@mixin generate-column-gaps {
    @each $i, $value in spacing.$SPACING {
        &-#{$i} {
            column-gap: var(--joy-core-spacing-#{$i});
        }
    }
}

.joy-wrapper {
  display: flex;
  gap: var(--wrapper-gap);
  flex-wrap: wrap;

  &--justify {
    &-flex-start {
      justify-content: flex-start;
    }

    &-flex-end {
      justify-content: flex-end;
    }

    &-center {
      justify-content: center;
    }

    &-space-between {
      justify-content: space-between;
    }
  }

  &--align {
    &-flex-start {
      align-items: flex-start;
    }

    &-flex-end {
      align-items: flex-end;
    }

    &-center {
      align-items: center;
    }

    &-stretch {
      align-items: stretch;
    }
  }

  &--direction {
    &-row {
      flex-direction: row;
    }

    &-column {
      flex-direction: column;
    }
  }

  &--wrap {
    &-wrap {
      flex-wrap: wrap;
    }

    &-nowrap {
      flex-wrap: nowrap;
    }
  }

  &--column-gap {
      &-0 {
          column-gap: 0;
      }

      @include generate-column-gaps();
  }

  &--row-gap {
      &-0 {
          row-gap: 0;
      }

      @include generate-row-gaps();
  }
}